import { MEDIA_URL } from '@/constants/env';

export const clients = [
  {
    id: 'astron',
    image: MEDIA_URL.concat('/clients/astron.png'),
    companies: ['construction'],
  },
  {
    id: 'bwsc',
    image: MEDIA_URL.concat('/clients/bwsc.png'),
    companies: ['construction'],
  },
  {
    id: 'damus',
    image: MEDIA_URL.concat('/clients/damus.png'),
    companies: ['construction', 'manpower'],
  },
  {
    id: 'ebs',
    image: MEDIA_URL.concat('/clients/ebs.png'),
    companies: ['construction'],
  },
  {
    id: 'iam-gold',
    image: MEDIA_URL.concat('/clients/iam-gold.png'),
    companies: ['engineering', 'construction'],
  },
  {
    id: 'sol',
    image: MEDIA_URL.concat('/clients/sol.png'),
    companies: ['engineering', 'construction'],
  },
  {
    id: 'newmount',
    image: MEDIA_URL.concat('/clients/newmount.png'),
    companies: ['construction'],
  },
  {
    id: 'surinaamse-brouwerij',
    image: MEDIA_URL.concat('/clients/surinaamse-brouwerij.png'),
    companies: ['construction'],
  },
  {
    id: 'spcs',
    image: MEDIA_URL.concat('/clients/spcs.png'),
    companies: ['construction', 'engineering'],
  },
  {
    id: 'staatsolie',
    image: MEDIA_URL.concat('/clients/staatsolie.png'),
    companies: ['engineering', 'manpower'],
  },
  {
    id: 'tampa',
    image: MEDIA_URL.concat('/clients/tampa.png'),
    companies: ['construction', 'manpower'],
  },
  {
    id: 'wartsilla',
    image: MEDIA_URL.concat('/clients/wartsilla.png'),
    companies: ['construction'],
  },
  {
    id: 'gow2',
    image: MEDIA_URL.concat('/clients/gow2.png'),
    companies: ['construction', 'engineering'],
  },
];
